// ──────────────────────────────────────────────────────────────
// 디자인 토큰 — 색상(C)·공통 스타일(S)·아바타 배경(AV). 화면 전체가 공유.
// 화면 컴포넌트 분리(#3)의 토대: 컴포넌트 파일들이 여기서 토큰을 import.
// (2026-06-18 모듈화 8단계)
// ──────────────────────────────────────────────────────────────
const C = {
  // 배경
  bg: '#FFF9F3', surface: '#FFFFFF', surfaceAlt: '#FBF6EE',
  // 텍스트
  text: '#1F2937', textSub: '#6B7280', textMute: '#9CA3AF',
  // 브랜드 — 가득 오렌지 단일
  primary: '#FF7A00', primarySub: '#FFE4CC', primaryDk: '#E66E00',
  // 구조
  divider: '#F1ECE4', border: '#EDE7DC',
  // 시그널
  success: '#10B981', warning: '#F59E0B', danger: '#EF4444',
  // 호환성 — 옛 키를 새 톤으로 매핑 (파스텔·블루 잔재 자동 흡수)
  secondary: '#FFE4CC', accent: '#FF7A00', purple: '#FF7A00', blue: '#FF7A00',
  hero: '#FFF9F3',
};

// 공통 스타일 토큰 — 당근 풍 따뜻한 가족 톤
const S = {
  card: { background: '#FFFFFF', borderRadius: 20, padding: 20, marginBottom: 12, boxShadow: '0 1px 3px rgba(31,41,55,0.04), 0 4px 12px rgba(31,41,55,0.05)', border: 'none' },
  cardFlat: { background: '#FBF6EE', borderRadius: 20, padding: 20, marginBottom: 12, border: 'none' },
  cardAccent: { background: '#FFE4CC', borderRadius: 20, padding: 20, marginBottom: 12, border: 'none' },
  cardWarm: { background: '#FFF3E6', borderRadius: 20, padding: 20, marginBottom: 12, border: 'none' },
  cardOutlined: { background: '#FFFFFF', borderRadius: 20, padding: 20, marginBottom: 12, border: '1px solid ' + C.divider, boxShadow: 'none' },
  input: { width: '100%', padding: '14px 16px', borderRadius: 14, border: '1.5px solid ' + C.divider, fontSize: 15, boxSizing: 'border-box', outline: 'none', background: '#FFFFFF', color: '#1F2937', transition: 'border-color 0.15s' },
  select: { width: '100%', padding: '14px 16px', borderRadius: 14, border: '1.5px solid ' + C.divider, fontSize: 15, background: '#FFFFFF', boxSizing: 'border-box', color: '#1F2937' },
  label: { fontSize: 13, fontWeight: 700, color: '#374151', marginBottom: 8, display: 'block' },
  btnPrimary: { padding: '14px 20px', borderRadius: 14, border: 'none', background: '#FF7A00', color: '#fff', fontSize: 15, fontWeight: 700, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, transition: 'all 0.15s', letterSpacing: '-0.01em' },
  btnGhost: { padding: '14px 20px', borderRadius: 14, border: 'none', background: '#FBF6EE', color: '#6B7280', fontSize: 14, fontWeight: 600, cursor: 'pointer', transition: 'all 0.15s' },
  btnOutline: { padding: '12px 18px', borderRadius: 14, border: '1.5px solid ' + C.divider, background: '#FFFFFF', color: '#374151', fontSize: 14, fontWeight: 600, cursor: 'pointer', transition: 'all 0.15s' },
  chip: { display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: 11, padding: '4px 10px', borderRadius: 999, background: '#FBF6EE', color: '#6B7280', fontWeight: 600, whiteSpace: 'nowrap' },
  chipAccent: { display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: 11, padding: '4px 10px', borderRadius: 999, background: '#FFE4CC', color: '#FF7A00', fontWeight: 700, whiteSpace: 'nowrap' },
  r: { sm: 8, md: 12, lg: 16, xl: 20, xxl: 24, full: 999 },
  spx: { xs: 8, sm: 12, md: 16, lg: 24, xl: 32, xxl: 48 },
  h1: { fontSize: 24, fontWeight: 800, color: '#1F2937', letterSpacing: '-0.025em', lineHeight: 1.3 },
  h2: { fontSize: 20, fontWeight: 700, color: '#1F2937', letterSpacing: '-0.02em', lineHeight: 1.4 },
  h3: { fontSize: 16, fontWeight: 700, color: '#1F2937', letterSpacing: '-0.015em', lineHeight: 1.4 },
  caption: { fontSize: 12, color: '#6B7280', fontWeight: 500, lineHeight: 1.5 },
};

// 아바타 배경 (가족 구성원 아이콘)
const AV = { dad: { bg: '#FBF6EE', e: '' }, mom: { bg: '#FBF6EE', e: '' }, boy: { bg: '#FF7A00', e: '' }, girl: { bg: '#FBF6EE', e: '' }, grandpa: { bg: '#FBF6EE', e: '' }, grandma: { bg: '#FBF6EE', e: '' }, family: { bg: 'linear-gradient(135deg,#87ceeb,#b8d4e3,#d4eaf7,#a8d8ea)', e: '' } };

module.exports = { C, S, AV };
